module.exports = __webpack_public_path__ + "media/images/fallback_video-ad542a5a45489b5988aaf597558e39b4.png";